import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getAccordionOverride } from './Accordion';
import { getButtonOverride } from './Button';
import { getHeaderNavigationActionItemOverride, getHeaderNavigationItemOverride, getHeaderNavigationLinkOverride, getHeaderNavigationMenuContentBodyOptionsOverride, getHeaderNavigationMenuContentHeaderOverride, getHeaderNavigationMenuOverride, getHeaderNavigationOverride, getHeaderNavigationSearchOverride, getHeaderNavigationSelectorDropdownOverride, getHeaderNavigationSelectorOverride, getHeaderNavigationTitleOverride } from './HeaderNavigation';
import { getPageNavigationOverride } from './PageNavigation';
import { getTextInputOverride } from './TextInput';
import { getTypographyOverride } from './Typography';
import { getCheckboxOverride } from './Checkbox';
import { getRadioOverride } from './Radio';
import { getSwitchOverride } from './Switch';
import { getMenuElementOverride } from './Navigation/MenuElement';
import { getMenuOverride } from './Navigation/Menu';
import { getTableRowOverride } from './Table/TableRow';
import { getTableCellOverride } from './Table/TableCell';
import { getTableExpandableSectionOverride } from './Table/TableExpandableSection';
import { getMessageOverride } from './Message';
import { getSearchClearActionOverride, getSearchEmptySuggestionsListOverride, getSearchOverride, getSearchSuggestionItemOverride } from './Search';
import { getTabOverride } from './Tab';
import { getTagOverride } from './Tag';
import { getTooltipOverride } from './Tooltip';
import { getBackdropOverride } from './Backdrop';
import { getDialogOverride, getDialogTitleOverride } from './Dialog';
import { getSideSheetOverride } from './SideSheet';
import { getDropdownBeforeSectionClearButtonOverride } from './DropdownBeforeSectionClearButton';
import { getOptionListItemOverride } from './OptionList/OptionListItem';
import { getOptionListOverride } from './OptionList/OptionList';
import { makeDatePickerOverride } from './DatePicker';
import { getContextMenuOverride } from './ContextMenu';
import { getIconButtonOverride } from './IconButton';
import { getTableCheckboxCellOverride } from './Table/TableCheckboxCell';
import { getTableHeadCellOverride } from './Table/TableHeadCell';
import { getLinkOverride } from './Link';
import { getListItemOverride } from './List/ListItem';
import { getCloseButtonOverride } from './CloseButton/CloseButton';
import { getTableControllerCellOverride } from './Table/TableControllerCell';
import { getActionSheetOverride } from './ActionSheet/ActionSheet';
export var darkThemeComponentOverrides = _objectSpread(_objectSpread({
  Accordion: getAccordionOverride,
  ActionSheet: getActionSheetOverride,
  Button: getButtonOverride,
  Dialog: getDialogOverride,
  DialogTitle: getDialogTitleOverride,
  DropdownBeforeSectionClearButton: getDropdownBeforeSectionClearButtonOverride,
  OptionListItem: getOptionListItemOverride,
  OptionList: getOptionListOverride,
  HeaderNavigation: getHeaderNavigationOverride,
  HeaderNavigationActionItem: getHeaderNavigationActionItemOverride,
  HeaderNavigationItem: getHeaderNavigationItemOverride,
  HeaderNavigationLink: getHeaderNavigationLinkOverride,
  HeaderNavigationMenu: getHeaderNavigationMenuOverride,
  HeaderNavigationMenuContentBodyOptions: getHeaderNavigationMenuContentBodyOptionsOverride,
  HeaderNavigationMenuContentHeader: getHeaderNavigationMenuContentHeaderOverride,
  HeaderNavigationSearch: getHeaderNavigationSearchOverride,
  HeaderNavigationSelector: getHeaderNavigationSelectorOverride,
  HeaderNavigationSelectorDropdown: getHeaderNavigationSelectorDropdownOverride,
  HeaderNavigationTitle: getHeaderNavigationTitleOverride,
  PageNavigation: getPageNavigationOverride,
  Search: getSearchOverride,
  SearchClearAction: getSearchClearActionOverride,
  SearchEmptySuggestionsList: getSearchEmptySuggestionsListOverride,
  SearchSuggestionItem: getSearchSuggestionItemOverride,
  SideSheet: getSideSheetOverride,
  TextInput: getTextInputOverride,
  Typography: getTypographyOverride,
  Checkbox: getCheckboxOverride,
  Radio: getRadioOverride,
  Switch: getSwitchOverride,
  MenuElement: getMenuElementOverride,
  Menu: getMenuOverride,
  Backdrop: getBackdropOverride,
  Tab: getTabOverride,
  Tag: getTagOverride,
  Tooltip: getTooltipOverride,
  TableRow: getTableRowOverride,
  TableCell: getTableCellOverride,
  TableCheckboxCell: getTableCheckboxCellOverride,
  TableControllerCell: getTableControllerCellOverride,
  TableHeadCell: getTableHeadCellOverride,
  TableExpandableSection: getTableExpandableSectionOverride,
  Message: getMessageOverride
}, makeDatePickerOverride()), {}, {
  ContextMenu: getContextMenuOverride,
  IconButton: getIconButtonOverride,
  Link: getLinkOverride,
  CloseButton: getCloseButtonOverride,
  ListItem: getListItemOverride
});